import { FILE_PICKER_CONSTANTS } from './file-picker-constants';
var FilePickerFoundation = /** @class */ (function () {
    function FilePickerFoundation(_adapter) {
        var _this = this;
        this._adapter = _adapter;
        this._accept = null;
        this._maxSize = null;
        this._capture = null;
        this._value = null;
        this._multiple = false;
        this._disabled = false;
        this._compact = false;
        this._borderless = false;
        this._buttonSlotListener = function (evt) { return _this._onButtonSlotChanged(evt); };
        this._inputChangeListener = function (evt) { return _this._onInputChange(evt); };
        this._dragEnterListener = function (evt) { return _this._onDragEnter(evt); };
        this._dragLeaveListener = function (evt) { return _this._onDragLeave(evt); };
        this._dragOverListener = function (evt) { return _this._onDragOver(evt); };
        this._dropListener = function (evt) { return _this._onDrop(evt); };
        this._adapter.registerButtonSlotListener(this._buttonSlotListener);
        this._adapter.registerInputChangeListener(this._inputChangeListener);
        if (!this._compact) {
            this._registerDragListeners();
        }
    }
    FilePickerFoundation.prototype.initialize = function () {
        this._adapter.initializeButton();
    };
    FilePickerFoundation.prototype._onButtonSlotChanged = function (evt) {
        this._adapter.initializeButton();
    };
    FilePickerFoundation.prototype._onInputChange = function (evt) {
        var files = evt.target.files;
        if (files) {
            this._handleFiles(files);
        }
    };
    FilePickerFoundation.prototype._onDragEnter = function (evt) {
        this._handleDragEvent(evt, true);
    };
    FilePickerFoundation.prototype._onDragLeave = function (evt) {
        this._handleDragEvent(evt, false);
    };
    FilePickerFoundation.prototype._onDragOver = function (evt) {
        this._handleDragEvent(evt, true);
    };
    FilePickerFoundation.prototype._onDrop = function (evt) {
        this._handleDragEvent(evt, false);
        if (!this._disabled) {
            var dataTransfer = evt.dataTransfer;
            if (dataTransfer) {
                var files = dataTransfer.files;
                this._handleFiles(files);
            }
        }
    };
    FilePickerFoundation.prototype._registerDragListeners = function () {
        this._adapter.registerDragEnterListener(this._dragEnterListener);
        this._adapter.registerDragLeaveListener(this._dragLeaveListener);
        this._adapter.registerDragOverListener(this._dragOverListener);
        this._adapter.registerDropListener(this._dropListener);
    };
    FilePickerFoundation.prototype._removeDragListeners = function () {
        this._adapter.removeDragEnterListener(this._dragEnterListener);
        this._adapter.removeDragLeaveListener(this._dragLeaveListener);
        this._adapter.removeDragOverListener(this._dragOverListener);
        this._adapter.removeDropListener(this._dropListener);
    };
    FilePickerFoundation.prototype._handleFiles = function (fileList) {
        var data = {};
        if (fileList) {
            var sortedFiles = this._sortFiles(fileList);
            var files = sortedFiles.legalFiles || null;
            // Ensure that we can only drop 1 file if not in multiple mode
            if (!this._multiple && files && files.length > 1) {
                files = files.splice(1);
            }
            this._value = files;
            data = sortedFiles;
        }
        this._adapter.emitHostEvent(FILE_PICKER_CONSTANTS.events.FILES_CHANGED, data);
    };
    FilePickerFoundation.prototype._sortFiles = function (files) {
        var legalFiles = [];
        var illegalFiles = [];
        if (!this._accept && !this.maxSize) {
            legalFiles = Array.from(files);
            return { legalFiles: legalFiles, illegalFiles: illegalFiles };
        }
        var formats = this._accept ? this._accept.split(',') : [''];
        formats.forEach(function (f) { return f.trim(); });
        var _loop_1 = function (i) {
            if (!formats.some(function (f) {
                return files[i].type.match(f) || files[i].name.match('\\' + f);
            }) || (this_1._maxSize && files[i].size > this_1._maxSize)) {
                illegalFiles.push(files[i]);
            }
            else {
                legalFiles.push(files[i]);
            }
        };
        var this_1 = this;
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < files.length; i++) {
            _loop_1(i);
        }
        return { legalFiles: legalFiles, illegalFiles: illegalFiles };
    };
    FilePickerFoundation.prototype._handleDragEvent = function (evt, isOverTarget) {
        if (!this._disabled) {
            evt.preventDefault();
            evt.stopPropagation();
            this._adapter.setHighlightState(isOverTarget);
        }
    };
    Object.defineProperty(FilePickerFoundation.prototype, "accept", {
        /** Get and set the allowed file types */
        get: function () {
            return this._accept;
        },
        set: function (value) {
            if (this._accept !== value) {
                this._accept = value;
                this._adapter.setAccept(value);
                if (value) {
                    this._adapter.setHostAttribute(FILE_PICKER_CONSTANTS.attributes.ACCEPT, value);
                }
                else {
                    this._adapter.removeHostAttribute(FILE_PICKER_CONSTANTS.attributes.ACCEPT);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerFoundation.prototype, "maxSize", {
        /** Get and set the maximum allowed file size */
        get: function () {
            return this._maxSize;
        },
        set: function (value) {
            if (this._maxSize !== value) {
                this._maxSize = value;
                if (value) {
                    this._adapter.setHostAttribute(FILE_PICKER_CONSTANTS.attributes.MAX_SIZE, value.toString());
                }
                else {
                    this._adapter.removeHostAttribute(FILE_PICKER_CONSTANTS.attributes.MAX_SIZE);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerFoundation.prototype, "capture", {
        /** Get and set the camera to use when capturing video or images */
        get: function () {
            return this._capture;
        },
        set: function (value) {
            if (this._capture !== value) {
                this._capture = value;
                this._adapter.setCapture(value);
                if (value) {
                    this._adapter.setHostAttribute(FILE_PICKER_CONSTANTS.attributes.CAPTURE, value);
                }
                else {
                    this._adapter.removeHostAttribute(FILE_PICKER_CONSTANTS.attributes.CAPTURE);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerFoundation.prototype, "value", {
        /** Get an array of Files with each selected file */
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerFoundation.prototype, "multiple", {
        /** Get and set whether multiple files are allowed */
        get: function () {
            return this._multiple;
        },
        set: function (value) {
            if (this._multiple !== value) {
                this._multiple = value;
                this._adapter.setMultiple(value);
                if (value) {
                    this._adapter.setHostAttribute(FILE_PICKER_CONSTANTS.attributes.MULTIPLE);
                }
                else {
                    this._adapter.removeHostAttribute(FILE_PICKER_CONSTANTS.attributes.MULTIPLE);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerFoundation.prototype, "disabled", {
        /** Get and set whether the file picker is disabled */
        get: function () {
            return this._disabled;
        },
        set: function (value) {
            if (this._disabled !== value) {
                this._disabled = value;
                this._adapter.setDisabled(value);
                if (value) {
                    this._adapter.setHostAttribute(FILE_PICKER_CONSTANTS.attributes.DISABLED);
                }
                else {
                    this._adapter.removeHostAttribute(FILE_PICKER_CONSTANTS.attributes.DISABLED);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerFoundation.prototype, "compact", {
        /** Get and set whether the file picker is compact */
        get: function () {
            return this._compact;
        },
        set: function (value) {
            if (this._compact !== value) {
                this._compact = value;
                this._adapter.setCompact(value);
                if (value) {
                    this._adapter.setHostAttribute(FILE_PICKER_CONSTANTS.attributes.COMPACT);
                    this._removeDragListeners();
                }
                else {
                    this._adapter.removeHostAttribute(FILE_PICKER_CONSTANTS.attributes.COMPACT);
                    this._registerDragListeners();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilePickerFoundation.prototype, "borderless", {
        /** Get and set whether the file picker is borderless */
        get: function () {
            return this._borderless;
        },
        set: function (value) {
            if (this._borderless !== value) {
                this._borderless = value;
                this._adapter.setBorderless(value);
                if (value) {
                    this._adapter.setHostAttribute(FILE_PICKER_CONSTANTS.attributes.BORDERLESS);
                }
                else {
                    this._adapter.removeHostAttribute(FILE_PICKER_CONSTANTS.attributes.BORDERLESS);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    return FilePickerFoundation;
}());
export { FilePickerFoundation };
